import { PROVIDERS, getProviderEnabled } from '@exodus/fiat-client'
import paypalProvider, { getWidgetUrl as getPaypalWidgetUrl } from '@exodus/fiat-client/paypal'

const createProvider = ({ assets, config, enabled, kyc, ...options } = {}) =>
  paypalProvider({
    ...options,
    enabled: (args) => getProviderEnabled({ ...args, enabled, kyc, provider: PROVIDERS.paypal }),
    url: config.URL,
  })

export const getWidgetUrl = ({ config, ...options }, ...parameters) =>
  getPaypalWidgetUrl({ ...options, url: config.URL }, ...parameters)

export default createProvider
